import { Box, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { Link, useLocation } from 'react-router-dom';
import { PrivateRoutes } from '@enums/privateRouteEnums';
import { useApp } from '@context/AppContext';

const Footer = () => {
  const { isTabletScreen } = useApp();
  const location = useLocation();

  const isRequestDrawPage = location.pathname.includes('/request-draw');
  const isReviewDrawPage = location.pathname.includes('/review-draw');
  const shouldHidePoweredBy = isTabletScreen && isRequestDrawPage;
  const shouldHideFooter =
    isTabletScreen && (isRequestDrawPage || isReviewDrawPage);

  if (shouldHideFooter) {
    return null;
  }

  return (
    <Box
      component="footer"
      sx={{
        p: 2,
        backgroundColor: 'background.paper',
        mt: 'auto',
        width: '100%',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
          color: 'text.secondary',
          fontSize: '14px',
        }}
      >
        <Grid sx={{ width: '100%' }} container>
          <Grid size={{ xs: 12, md: 6 }}>
            <Box>
              {!shouldHidePoweredBy && (
                <>
                  <Typography variant="body2">
                    Powered by The Mortgage Office
                  </Typography>
                  <Typography variant="body2">
                    Copyright © Applied Business Software, Inc. All Rights
                    Reserved
                  </Typography>
                </>
              )}
            </Box>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <Box
              sx={{
                display: 'flex',
                gap: 3,
                justifyContent: { xs: 'center', md: 'flex-end' },
                mt: { xs: 2, md: 1 },
              }}
            >
              <Link
                to={PrivateRoutes.CONTACT}
                style={{ color: 'inherit', textDecoration: 'none' }}
              >
                Contact Us
              </Link>
              <Typography variant="body2">|</Typography>
              <Link
                to={PrivateRoutes.PRIVACY}
                style={{ color: 'inherit', textDecoration: 'none' }}
              >
                Your Privacy
              </Link>
              <Typography variant="body2">|</Typography>
              <Link
                to={PrivateRoutes.TERMS}
                style={{ color: 'inherit', textDecoration: 'none' }}
              >
                Terms of Use
              </Link>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default Footer;
